import React, { useCallback, useEffect, useState } from 'react';
import { Box, Container, makeStyles } from '@material-ui/core';
import { Page } from 'src/components';
import Toolbar from './Toolbar';
import Suppliers from './Suppliers';
import { LoaderBar } from 'src/components';
import { slices, useAppDispatch, useAppSelector } from 'src/redux';
import { Pagination } from '@material-ui/lab';

const {
  actions: supplierActions,
  selectors: supplierSelectors
} = slices.supplier;

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  productCard: {
    height: '100%'
  }
}));

const SupplierList = () => {
  const classes = useStyles();
  const dispatch = useAppDispatch();

  const suppliers = useAppSelector(supplierSelectors.selectSupplierList);
  const meta = useAppSelector(supplierSelectors.selectMeta);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [searchText, setSearchText] = useState('');

  const getSuppliers = useCallback(
    async (page: number = 1) => {
      setIsLoading(true);
      dispatch(
        supplierActions.getSuppliersThunk({ keyword: searchText || null, page })
      ).finally(() => setIsLoading(false));
    },
    [dispatch, searchText]
  );

  const onSupplierPress = (id: number) => {
    if (!id) {
      console.error('Invalid supplier id');
      return;
    }
    window.open(`/app/suppliers/${id}`, '_blank');
  };

  const handleChange = (event: React.ChangeEvent<any>, value: number) => {
    if (value !== meta?.current_page) {
      getSuppliers(value);
    }
  };

  useEffect(() => {
    getSuppliers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Page className={classes.root} title="Suppliers">
      <Container maxWidth={false}>
        <Toolbar setSearchText={setSearchText} getSupplierData={getSuppliers} />
        <Box mt={2}>
          <LoaderBar isLoading={isLoading} />
          <Suppliers onSupplierPress={onSupplierPress} suppliers={suppliers} />
        </Box>
      </Container>
      <Box display="flex" justifyContent="flex-end" p={2}>
        <Pagination
          count={meta?.last_page ?? 1}
          page={meta?.current_page ?? 1}
          onChange={handleChange}
        />
      </Box>
    </Page>
  );
};

export default SupplierList;
